<template>
  <div class="digital-block">
    <p class="digital-block__subtitle">
      {{ title }}
    </p>
    <pInput
        :value="first"
        :placeholder="firstPlaceholder"
        type="number"
        @input="(event) => emit('update:first', event.target.value)"
    />
    <span class="digital-block__text">
        {{ orText }}
    </span>
    <pInput
        :value="second"
        :placeholder="secondPlaceholder"
        type="number"
        @input="(event) => emit('update:second', event.target.value)"
    />
  </div>
</template>

<script setup lang="ts">
import pInput from '@/common/pInput/pInput.vue'

const emit = defineEmits<{
  (e: 'update:first', value: string): void
  (e: 'update:second', value: string): void
}>()

defineProps({
  first: {
    type: String,
    required: true,
  },
  second: {
    type: String,
    required: true,
  },
  title: {
    type: String,
    required: true,
  },
  orText: {
    type: String,
    required: true,
  },
  firstPlaceholder: {
    type: String,
    default: '',
  },
  secondPlaceholder: {
    type: String,
    default: '',
  },
})
</script>

<style scoped lang="scss">
.digital-block {
  display: grid;
  grid-template-columns: 1fr auto 1fr;
  align-items: center;
  column-gap: 4px;
  row-gap: 8px;

  &__subtitle {
    grid-column: 1/4;
    font-weight: 700;
  }

  &__text {
    font-weight: 600;
  }
}
</style>